import { twMerge } from 'tailwind-merge';
import { Controller, useFormContext } from 'react-hook-form';

// ----------------------------------------------------------------------

export type RHFTextareaFieldProps = React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
  name: string;
  label?: string;
  helperText?: string;
  fullWidth?: boolean;
};

export function RHFTextareaField({
  name,
  label,
  helperText,
  className,
  fullWidth = true,
  rows = 4,
  ...other
}: RHFTextareaFieldProps) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const hasValue = field.value !== undefined && field.value !== null && field.value !== '';

        return (
          <div className={twMerge(['flex flex-col', fullWidth && 'w-full'])}>
            <div className="relative">
              <textarea
                {...field}
                id={name}
                rows={rows}
                placeholder=" "
                autoComplete="new-password"
                className={twMerge([
                  'peer w-full px-3 pt-2 pb-2 text-sm resize-none',
                  'rounded-md border outline-none transition-all',
                  'bg-white border-gray-300 focus:ring-2 focus:ring-[#1C252E] focus:border-[#1C252E]',
                  error && 'border-error focus:ring-error-dark focus:border-error-dark',
                  className,
                ])}
                {...other}
              />

              {label && (
                <label
                  htmlFor={name}
                  className={twMerge([
                    'absolute left-2 px-1 bg-white pointer-events-none transition-all',
                    'top-4 text-sm',
                    error ? 'text-error-dark' : 'text-gray-500',
                    'peer-focus:top-0 peer-focus:text-xs peer-focus:-translate-y-1/2',
                    !error && 'peer-focus:text-[#1C252E]',
                    hasValue && 'top-0 text-xs -translate-y-1/2',
                  ])}
                >
                  {label}
                </label>
              )}
            </div>

            <p
              className={twMerge([
                'mt-1 text-left text-xs md:text-sm',
                error ? 'text-error-dark' : 'text-gray-500',
              ])}
            >
              {error?.message || helperText}
            </p>
          </div>
        );
      }}
    />
  );
}
